import { render, staticRenderFns } from "./BP_bkp_page.vue?vue&type=template&id=715f602b&scoped=true"
import script from "./BP_bkp_page.vue?vue&type=script&lang=js"
export * from "./BP_bkp_page.vue?vue&type=script&lang=js"
import style0 from "./BP_bkp_page.vue?vue&type=style&index=0&id=715f602b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715f602b",
  null
  
)

export default component.exports